import { FC } from 'react';
import { Box } from '@hopskipdrive/react-components';

import { ProfileImage } from '../ProfileImage';
import { ProfileInitials } from '../ProfileInitials';
import { colorTokens } from '../variables';

interface PhotoOrInitialsProps {
  pictureUrl?: string;
  key?: string;
  fullName: string;
  size?: number;
  fontSize?: number;
}

export const PhotoOrInitials: FC<PhotoOrInitialsProps> = ({ pictureUrl, key, fullName, size = 92, fontSize = 20 }) => {
  return (
    <Box width={size} height={size}>
      {pictureUrl ? (
        <ProfileImage
          key={key}
          imgSrc={pictureUrl || ''}
          style={{ border: `1px solid ${colorTokens.primary.contrast}` }}
          size={size}
        />
      ) : (
        <ProfileInitials key={key} fullName={fullName} size={size} fontSize={fontSize} />
      )}
    </Box>
  );
};
